import { ProfilePageLayout } from '@modules/_shared/components/ProfilePageLayout';
import { useLocale } from '@shared/hooks/locale';

export const PlansTrialing = () => {
  const { t } = useLocale();
  return (
    <ProfilePageLayout
      intent="claim"
      target="agent"
      agentAction="trial"
      ctaLabel={t('Start free trial')}
      title={t('Welcome to RealAdvisor')}
      description={t(
        'Start your free trial and get access to leads, visibility tools and CMA reports.',
      )}
    />
  );
};
